import React from "react";
import { Form, Input as AntInput } from "antd";
import Props from "./Props";

const Input: React.FC<Props> = ({ name, config, ...rest }) => (
  <Form.Item
    name={name}
    label={config.label}
    rules={config.validationRules}
    labelCol={{ span: 24 }}
    className={config.className}
    {...(config.extra || {})}
    {...rest}
  >
    <AntInput.TextArea placeholder={config.placeholder} />
  </Form.Item>
);

export default Input;
